export default {
      id: "i-menu-services-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-menu-services",
      toString: function () {
        return this.url;
      }
    }